module.exports = __webpack_public_path__ + "static/img/game-2.c303a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game-2.png
// module id = zbkU
// module chunks = 1